import CertificateBlock from "../CertificationBlock/CertificationBlock";


function CertificateList({ children, isDark, enableLinks, certificates, onRemove, ...props }) {
    return (
        <div {...props}>
            {certificates && certificates.map((single) => {
                return (
                    <CertificateBlock
                        key={single.id}
                        id={single.id}
                        isDark={isDark}
                        enableLinks={enableLinks}
                        name={single.name}
                        issueDate={single.issueDate}
                        certificate={single.certificate}
                        onRemove={onRemove}
                    />
                )
            })}
        </div>
    );
}

export default CertificateList
